import classNames from 'clsx';
import React from 'react';

import PlayIconShadow from '@swf/core/assets/casino/play-icon-shadow.svg';
import PlayIcon from '@swf/core/assets/casino/play-icon.svg';

import styles from './RoundPlayButton.scss';

export interface Props {
  title?: string;
  className?: string;
  onClick?(): void;
}

const RoundPlayButton: React.FC<Props> = ({ className, title, onClick }) => (
  <>
    <button
      className={classNames(className, styles.playButton)}
      onClick={() => onClick && onClick()}
      title={title}
    >
      <PlayIcon />
    </button>
    <PlayIconShadow className={classNames(className, styles.playButtonShadow)} />
  </>
);

export default RoundPlayButton;
